import { Route } from '@angular/router';
import { SubscriptionsListComponent } from './subscriptions-list.component';
import { AuthGuard } from '../../../shared/services';
import { AssociationsForFilterResolver } from '../../associations/associations-for-filter/associations-for-filter.resolver';

export const SubscriptionsListRoutes: Route[] = [
    {
      path: 'list',
      component: SubscriptionsListComponent,
      canActivate: [AuthGuard],
       resolve: {
         assocsForFilter: AssociationsForFilterResolver
       }
    }
  ];
